import { Typography } from '@material-ui/core'
import SiteDetails from '../SiteDetails'
import { useStyles } from './styles'
const SiteApplicationDetails = (props) => {
  const { site, setLoading, getSites } = props
  const classes = useStyles()
  return (
    <div className={classes.layout}>
      <Typography className={classes.sidetext}>Application Details</Typography>
      <SiteDetails
        getSites={getSites}
        setLoading={setLoading}
        site={site}
      ></SiteDetails>
    </div>
  )
}
export default SiteApplicationDetails
